<template>
<div>
  <div>User: <br>
    <pre>
    {{ user }}
    </pre>
  </div>
    <div>ApiToken (used to exchange for auth0 management accesstoken): <br>
    <pre>
    {{ auth.apiToken }}
    </pre><br>
    <h4>Decoded JWT Token</h4>>
    <pre>{{ decodedToken }}</pre>
        <h4>ID Token</h4>>
    <pre>{{ auth.idToken }}</pre>
  </div>
</div>
</template>

<script>

import { mapActions } from 'vuex';
import jwt_decode from 'jwt-decode';

  export default {
    name: 'profile',
  
    data() {
      return {
        activeTab: 0,

        auth: {
          apiToken: null,
          user: {},
          access_token: null,
          idToken: null,
        },
        user: {},
        ports: null,
      };
    },
    async mounted() {
      await this.getUserData();
    },
    methods: {
      ...mapActions(['getLoggedInUser','getToken','getIdToken']),
      login() {
        // this.$auth.loginWithRedirect();
      },
      async getUserData() {
        this.user = await this.getLoggedInUser()
        this.auth.apiToken = await this.getToken()
        this.auth.idToken = await this.getIdToken()
      },
    },
    computed: {
      decodedToken: function() {
        if (this.auth && this.auth.apiToken) {
          return jwt_decode(this.auth.apiToken)
        } else {
          return "No token to decode"
        }
      }
    }
  }
</script>

<style>
  .picture-container {
    display: flex;
    justify-content: right;
    align-items: flex-end;
    float: right;
  }

  .profile-pic {
   display: block;
  max-width:400px;
  max-height:400px;
  width: auto;
  height: auto;
  border-radius: 50%;
  }
</style>
